import { create } from "zustand";

export type Theme = "light" | "dark";

const STORAGE_KEY = "mentoria_theme";

/** Mirrors the inline script in index.html, which runs before first paint. */
function resolveInitialTheme(): Theme {
  if (typeof document === "undefined") return "light";
  const stamped = document.documentElement.dataset.theme;
  if (stamped === "light" || stamped === "dark") return stamped;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggle: () => void;
}

/** Theme is set once at the root. Sections never invert individually. */
export const useTheme = create<ThemeState>((set, get) => ({
  theme: resolveInitialTheme(),
  setTheme: (theme) => {
    document.documentElement.dataset.theme = theme;
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // Private-mode browsers reject writes; the in-memory theme still applies.
    }
    set({ theme });
  },
  toggle: () => get().setTheme(get().theme === "dark" ? "light" : "dark"),
}));
